import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';

import { EditIcon, TrashIcon } from '../../components/icons';
import { Pagination } from '../../components';

import { TABLE_HEAD } from './constants';

import useStyles from './styles';

const EmployeesTable = props => {
  const {
    data,
    openEditUser,
    deleteUserHandler,
    page,
    onPageChangeHandler
  } = props;
  const [isUpdate, setIsUpdate] = React.useState(false);
  const classes = useStyles();
  const [t] = useTranslation();

  return (
    <TableContainer component="div" classes={{ root: classes.container }}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            {TABLE_HEAD(classes).map(heading => (
              <TableCell
                key={heading.label}
                align={heading.align}
                style={{ paddingBottom: 15 }}
                className={classNames(
                  classes.tableCell,
                  classes.heading,
                  heading.cellClassName
                )}
              >
                {t(heading.label)}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data &&
            data.businessOwners &&
            data.businessOwners.map(user => (
              <TableRow key={user.id} classes={{ root: classes.tableRow }}>
                <TableCell
                  style={{ paddingBottom: 5, paddingTop: 5 }}
                  className={classNames(classes.tableCell, classes.nameCell)}
                  align="left"
                >
                  {user.firstName} {user.lastName}
                </TableCell>
                <TableCell
                  style={{ paddingBottom: 5, paddingTop: 5 }}
                  className={classNames(classes.tableCell, classes.emailCell)}
                  align="left"
                >
                  {user.email}
                </TableCell>
                <TableCell
                  style={{ paddingBottom: 5, paddingTop: 5 }}
                  className={classNames(classes.tableCell, classes.phoneCell)}
                  align="left"
                >
                  {user.phoneNumber}
                </TableCell>
                
                <TableCell
                  style={{ paddingBottom: 5, paddingTop: 5 }}
                  className={classNames(classes.tableCell, classes.phoneCell)}
                  align="left"
                >
                 {user.isNotify ? 'ON' : 'OFF'}
                </TableCell>


                <TableCell
                  style={{ paddingBottom: 5, paddingTop: 5 }}
                  className={classes.tableCell}
                  align="right"
                >
                  <div style={{ display: 'inline-flex', paddingRight: '10px' }}>
                    <IconButton
                      className={classes.iconButton}
                      disableTouchRipple={true}
                      disableFocusRipple={true}
                      aria-label="edit"
                      onClick={e => {
                        e.stopPropagation();
                        setIsUpdate(true);
                        openEditUser(user);
                      }}
                    >
                      <EditIcon />
                    </IconButton>
                    <IconButton
                      disableTouchRipple={true}
                      disableFocusRipple={true}
                      className={classes.iconButton}
                      aria-label="delete"
                      onClick={e => {
                        e.stopPropagation();
                        deleteUserHandler(user);
                      }}
                    >
                      <TrashIcon />
                    </IconButton>
                  </div>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>

      {data && (
        <Pagination
          page={page + 1}
          count={data.numberOfOwnersPages}
          onChange={(e, page) => onPageChangeHandler(page)}
          amount={data.businessOwners.length}
          total={data.businessOwnersOverview.total}
        />
      )}
    </TableContainer>
  );
};

export default EmployeesTable;
